<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
export default {
  components: {},
  provide () {
    return {
      reload: this.reload // this.reload方法注入 到reload参数中，从子组件获取
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    }
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
}

.menber-info-detail-table {
  table-layout: fixed;
  word-wrap:break-word;
  word-break:break-all;
}

/** 悬浮提示自动换行显示完整**/
.ivu-tooltip-inner {
  white-space: normal !important;
  word-break: break-word !important;
}
</style>
